<template>
<div id="scene-container" ref="sceneContainer">
    <div id="ui-container" ref="uiContainer">
        <Gate3dMetadata ref="gateMeta" v-bind:gateName="this.$router.currentRoute.name" />
    </div>
</div>
</template>

<script>
import * as THREE from 'three'
import {
  OrbitControls
} from 'three/examples/jsm/controls/OrbitControls'
import {
  GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader'
import {
  Audio
} from 'three/src/audio/Audio'
import {
  AudioLoader
} from 'three/src/loaders/AudioLoader'
import {
  AudioListener
} from 'three/src/audio/AudioListener'
import {
  PositionalAudio
} from 'three/src/audio/PositionalAudio'
import Gate3dMetadata from "@/components/Gate3dMetadata";

/*
import Stats from "stats.js";
*/

export default {
  name: "Explore",
  components: {
    Gate3dMetadata
  },
  data() {
    return {
      container: null,
      scene: null,
      camera: null,
      controls: null,
      renderer: null,
      /*stats: null,*/
      listener: null,
      ambience: null,
      positional: [],
      positionalPaths: [
        '/audio/gates/Explore/Explore_Blue.mp3',
        '/audio/gates/Explore/Explore_Green.mp3',
        '/audio/gates/Explore/Explore_Yellow.mp3',
      ],
      mapObject: null,
      gates: {
        blue: null,
        green: null,
        yellow: null,
        violet: null,
        indigo: null,
        turquoise: null,
        red: null,
        orange: null,
      },
      gateClickSound: null,
      gateClickPath: '/audio/gates/Explore/Explore_Gate_Click.mp3',
    }
  },
  methods: {

    async init() {

      // set container
      this.container = this.$refs.sceneContainer

      /*      // add stats
            this.stats = new Stats()
            this.container.appendChild(this.stats.dom)*/

      // add camera
      const fov = 30 // Field of view
      const aspect = window.innerWidth / window.innerHeight
      const near = 1 // the near clipping cutoutPlane
      const far = 300 // the far clipping cutoutPlane
      const camera = new THREE.PerspectiveCamera(fov, aspect, near, far)
      camera.position.set(-20, 40, 20)
      camera.minPolarAngle = Math.PI / 7;
      camera.maxPolarAngle = Math.PI / 4;

      this.camera = camera

      // create scene
      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color(0xcccccc)

      // add lights
      // const ambientLight = new THREE.HemisphereLight(
      //     0xffffff, // bright sky color
      //     0x222222, // dim ground color
      //     1 // intensity
      // )
      // const mainLight = new THREE.DirectionalLight(0xffffff, 4.0)
      // mainLight.position.set(10, 10, 10)
      // this.scene.add(ambientLight, mainLight)

      const skyColor = 0xffffff; // #ffffff
      const groundColor = 0x222222; // #222222
      const intensity = 1.25;
      const ambientLight = new THREE.HemisphereLight(skyColor, groundColor, intensity);
      this.scene.add(ambientLight)

      // add controls
      this.controls = new OrbitControls(this.camera, this.container)
      this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
      this.controls.dampingFactor = 0.04;
      this.controls.screenSpacePanning = false;
      this.controls.enableZoom = false;
      this.controls.minDistance = 22;
      this.controls.maxDistance = 50;
      this.controls.autoRotate = true;
      this.controls.autoRotateSpeed = 0.5;
      this.controls.minPolarAngle = Math.PI / 7;
      this.controls.maxPolarAngle = Math.PI / 4;

      // create renderer
      this.renderer = new THREE.WebGLRenderer({
        antialias: true
      })
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.gammaFactor = 2.2
      this.renderer.outputEncoding = THREE.sRGBEncoding
      this.renderer.physicallyCorrectLights = true
      this.container.appendChild(this.renderer.domElement)

      // set the mouse & raycaster
      this.mouse = new THREE.Vector2()
      this.raycaster = new THREE.Raycaster();

      // load and add gltf gate cubes to the scene
      this.mapObject = await this.loadGeometryAsync()
      this.scene.add(this.mapObject.scene)
      this.assignGates()

      //audio part
      this.listener = new AudioListener()

      this.camera.add(this.listener)
      await this.loadPlayAmbienceAsync()

      await this.loadPlayPositionalAsync(this.positionalPaths[0], this.gates.blue)
      await this.loadPlayPositionalAsync(this.positionalPaths[1], this.gates.green)
      await this.loadPlayPositionalAsync(this.positionalPaths[2], this.gates.yellow)

      this.fadeAudioVolume(this.ambience, 0, 1, 5)
      this.fadeAudioVolume(this.positional[0], 0, 1.8, 5)
      this.fadeAudioVolume(this.positional[1], 0, 1.8, 5)
      this.fadeAudioVolume(this.positional[2], 0, 1.8, 5)

      await this.loadGateClick()

    },


    render() {
      this.renderer.render(this.scene, this.camera)

    },

    animate() {
      this.renderer.setAnimationLoop(() => {
        this.render()
        this.controls.update()
        /*
                this.stats.update()
        */
      })
      this.establishListeners()
    },

    stopAnimating() {
      this.renderer.setAnimationLoop(null);
    },

    establishListeners() {
      window.addEventListener('resize', this.onWindowResize.bind(this), false)
      this.container.addEventListener('click', this.onMouseClick.bind(this), false)
      this.controls.addEventListener('start', this.toggleAutoRotate.bind(this), false)
      this.controls.addEventListener('end', this.toggleAutoRotate.bind(this), false)

    },

    toggleAutoRotate() {
      this.controls.autoRotate = !this.controls.autoRotate
    },

    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },

    assignGates() {
      this.gates.blue = this.scene.getObjectByName('blue');
      this.gates.green = this.scene.getObjectByName('green');
      this.gates.yellow = this.scene.getObjectByName('yellow');
      this.gates.violet = this.scene.getObjectByName('violet');
      this.gates.indigo = this.scene.getObjectByName('indigo');
      this.gates.turquoise = this.scene.getObjectByName('turquoise');
      this.gates.red = this.scene.getObjectByName('red');
      this.gates.orange = this.scene.getObjectByName('orange');


    },
    onMouseClick(event) {
      this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      this.raycaster.setFromCamera(this.mouse, this.camera);
      let intersects = this.raycaster.intersectObjects(this.scene.children, true);


      if (intersects.length > 0) {

        {
          switch (intersects[0].object) {
            case this.gates.blue:
              this.gateClickSound.play()
              this.$router.push('/explore/blue');
              break;
            case this.gates.green:
              this.gateClickSound.play()
              this.$router.push('/explore/green');
              break;
            case this.gates.yellow:
              this.gateClickSound.play()
              this.$router.push('/explore/yellow');
              break;
            case this.gates.violet:
              this.gateClickSound.play()
              this.$router.push('/explore/violet');
              break;
            case this.gates.indigo:
              this.gateClickSound.play()
              this.$router.push('/explore/indigo');
              break;
            case this.gates.turquoise:
              this.gateClickSound.play()
              this.$router.push('/explore/turquoise');
              break;
            case this.gates.red:
              this.gateClickSound.play()
              this.$router.push('/explore/red');
              break;
            case this.gates.orange:
              this.gateClickSound.play()
              this.$router.push('/explore/orange');
              break;
          }
        }

      }

    },
    loadGeometryAsync: function() {
      return new Promise((resolve) => {
        const loader = new GLTFLoader()
        loader.load(
            '/models/explore.glb',
            model => {
              resolve(model)
            },
            undefined,
            undefined
        )
      })
    },

    loadPlayAmbienceAsync() {
      this.ambience = new Audio(this.listener)
      return new Promise((resolve) => {
        if (!this.ambience.isPlaying) {
          const loader = new AudioLoader()
          loader.load(
              '/audio/gates/Explore/Explore_Static_on_camera.mp3',
              buffer => {
                this.ambience.setBuffer(buffer)
                this.ambience.setLoop(true)
                this.ambience.setVolume(0)
                this.ambience.play()
                resolve(buffer)
              },
              undefined,
              undefined
          )
        }
      })
    },

    loadPlayPositionalAsync(trackPath, targetObject) {
      let tempPositional = new PositionalAudio(this.listener)
      this.positional.push(tempPositional)
      return new Promise((resolve) => {
        const loader = new AudioLoader()
        loader.load(
            trackPath,
            buffer => {
              tempPositional.setBuffer(buffer)
              tempPositional.setLoop(true)
              tempPositional.setVolume(0)
              tempPositional.setRefDistance(10.0)
              tempPositional.play()
              targetObject.add(tempPositional)
              resolve(buffer)
            },
            undefined,
            undefined
        )
      })
    },

    fadeAudioVolume(audioTrack, from, to, overSeconds) {
      let framerate = 20
      let toIncrement = ( ( to - from ) * framerate) / (overSeconds*1000)
      let interval = setInterval(() => {
        let currentValue = parseFloat(audioTrack.getVolume())

        if (currentValue >= to) {
          clearInterval(interval)
        }
        currentValue = (!isNaN(currentValue) ? currentValue + toIncrement: toIncrement)
        audioTrack.setVolume(currentValue)
      }, framerate)
    },

    loadGateClick(){
      this.gateClickSound = new Audio(this.listener)
      return new Promise((resolve) => {
          const loader = new AudioLoader()
          loader.load(
              this.gateClickPath,
              buffer => {
                this.gateClickSound.setBuffer(buffer)
                this.gateClickSound.setLoop(false)
                this.gateClickSound.setVolume(1)
                resolve(buffer)
              },
              undefined,
              undefined
          )
      })
    }


  },
  mounted() {
    this.init().then(() => this.animate())
  },
  beforeDestroy() {
    this.stopAnimating()
    this.ambience.pause()
    for (let i = 0; i < this.positional.length; i++) {
      this.positional[i].pause()
    }
  },

}
</script>

<style scoped>
#scene-container {
  height: 100%;
  overflow: hidden;
  z-index: 96;
}

#ui-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 97;
    /* pointer-events: auto; */
}
</style>
